export function degrees2radians(degrees) {
  return (degrees * Math.PI) / 180;
}

export function radians2degrees(rads) {
  return (rads * 180) / Math.PI;
}
